module.exports = __webpack_public_path__ + "img/ctrl-sqrt-swap-1.3f8a1569.svg";